import { Heading, HStack, VStack } from '@chakra-ui/react'
import { FC } from 'react'
import { SkeletonTab, Tab } from './EditorTabs'
import { RoomMetadata } from '../../auto-generated-clients/content-delivery-client-v3.generated'
import { LearningEvent } from '../../auto-generated-clients/learning-management-client-v1.generated'
import { v4 as uuid } from 'uuid'

interface EditorViewTabsProps {
  selectedRoom: RoomMetadata
  onAddLearningEvent: () => void
  onEventClick: (event: LearningEvent) => void
  selectedEvent: LearningEvent | undefined
  learningEvents: LearningEvent[]
  isLoading: boolean
}

const NUMBER_OF_LOADING_TABS = 3

export const EditorViewTabs: FC<EditorViewTabsProps> = ({
  onAddLearningEvent,
  onEventClick,
  selectedRoom,
  selectedEvent,
  learningEvents,
  isLoading,
}) => {
  const renderTabs = () => {
    if (isLoading) {
      return Array.from({ length: NUMBER_OF_LOADING_TABS }).map(() => (
        <SkeletonTab key={uuid()} />
      ))
    }

    return learningEvents.map((event) => {
      const isSelected =
        selectedEvent?.learningEventId === event.learningEventId

      return (
        <Tab
          key={event.learningEventId}
          selected={isSelected}
          tabName={event.learningEventName}
          onClick={() => onEventClick(event)}
        />
      )
    })
  }

  return (
    <VStack
      alignItems={'flex-start'}
      bg={'secondary.0'}
      borderRadius={'xl'}
      p={4}
      width={'full'}>
      <HStack paddingY={4}>
        <Heading lineHeight={0} fontSize={'3xl'}>
          {selectedRoom.roomName}
        </Heading>
      </HStack>
      <HStack overflow={'auto'} width={'full'} paddingBottom={2}>
        {renderTabs()}
        <Tab tabName={'+'} onClick={onAddLearningEvent} />
      </HStack>
    </VStack>
  )
}
